import React from 'react';

/**
 * A number that opens its drill when it has one, and is plain text when it does not.
 *
 * With no `drill` it renders a bare span — never a disabled or fake button — so a
 * number whose drill is unconfirmed cannot look clickable.
 *
 * @param {object} props
 * @param {{what:string,id:string,scope:object}|null} [props.drill]  From drillTargetFor.
 * @param {string} [props.label]   Accessible name of the button, naming the bucket ("See the 2 blocked items").
 * @param {(drill: object) => void} [props.onOpen]
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children  The number and its words.
 */
export default function DrillNumber({ drill = null, label, onOpen, className = '', children }) {
  if (!drill) return <span className={className}>{children}</span>;
  return (
    <button
      type="button"
      aria-label={label}
      onClick={() => onOpen?.(drill)}
      className={`rounded underline-offset-2 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand ${className}`}
    >
      {children}
    </button>
  );
}
